import React, { forwardRef, useLayoutEffect, useRef, useState } from 'react';

/**
 * Feste Buehne fuer Kit-Bausteine: innen immer `width × height` Pixel
 * (Karten in App-Originalgroesse), aussen auf die verfuegbare Breite
 * skaliert. So bleibt eine Komposition auf 390 px exakt dieselbe wie auf
 * 1440 px, nur kleiner — kein zweites Layout, keine gequetschten Karten.
 *
 * Der innere Knoten (ref) ist der Container fuer useKitScene.
 */
const ScaledStage = forwardRef(({ width, height, maxScale = 1, className = '', innerClassName = '' }, ref) => {
  const outerRef = useRef(null);
  const [scale, setScale] = useState(maxScale);

  useLayoutEffect(() => {
    const el = outerRef.current;
    if (!el) return undefined;
    const update = () => {
      const w = el.clientWidth;
      if (w > 0) setScale(Math.min(maxScale, w / width));
    };
    update();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [width, maxScale]);

  return (
    <div ref={outerRef} className={className} style={{ height: Math.round(height * scale) }} aria-hidden="true">
      <div style={{ width: width * scale, height: height * scale, margin: '0 auto', position: 'relative' }}>
        <div
          ref={ref}
          className={`eo eo-illustration absolute left-0 top-0 ${innerClassName}`}
          style={{ width, height, transform: `scale(${scale})`, transformOrigin: '0 0' }}
        />
      </div>
    </div>
  );
});

ScaledStage.displayName = 'ScaledStage';

export default ScaledStage;
